
 
 <img class="wave" src="../assets/images/wave_yellow.svg">
 <main class="login_wrapper my3">
	 
	 <div class="container">
	 
			 <div class="row login-box-12 container-box">
			 
				
			 
				 <div class="col-lg-12 col-sm-12" style=" background: #f7fbff80;">
					 <div class="login-inner-form">
						 <div class="details">
							<div class="d-flex align-items-center">
								
									
							</div>
							 
							 <h5 class="mb-3">Error occured.. </h5>
			   <div class="d-flex flex-column mb-3">
				
				 </div>
	
						 </div>
					 </div>
				 </div>
			 
			 </div>
	 
	 </div>
	 
	 <div>
		
	 </div>
 </main>